import React, { useState, useEffect } from 'react';
import { Cloud, FolderOpen, Server } from 'lucide-react';
import OneDriveCard from '../components/Configuracion/OneDriveCard';
import { getNetlifyFunctionUrl } from '../config/netlify';
import './Configuracion.css';

const ConfiguracionOneDrive = () => {
  const [folderPath, setFolderPath] = useState('');
  const [environment, setEnvironment] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOneDriveConfig();
  }, []);

  const fetchOneDriveConfig = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(getNetlifyFunctionUrl('onedrive-config'), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();

      if (result.success) {
        setFolderPath(result.data.folderPath);
        setEnvironment(result.data.environment);
      } else {
        setError(result.error || 'Error al obtener configuración');
      }
    } catch (err) {
      console.error('Error fetching OneDrive config:', err);
      setError('Error al conectar con el servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="configuracion-container">
      <div className="configuracion-header">
        <h1 className="configuracion-title">Configuración - OneDrive</h1>
        <p className="configuracion-subtitle">
          Gestiona la conexión con Microsoft OneDrive para almacenamiento de archivos
        </p>
      </div>
      
      <div className="configuracion-content">
        {/* Sección OneDrive */}
        <section className="config-section">
          <div className="config-section-header">
            <Cloud size={24} className="config-section-icon" />
            <h2 className="config-section-title">OneDrive</h2>
          </div>
          
          <div className="config-section-content">
            <OneDriveCard />
          </div>
        </section>

        {/* Sección Configuración del Servidor */}
        <section className="config-section">
          <div className="config-section-header">
            <Server size={24} className="config-section-icon" />
            <h2 className="config-section-title">Configuración del Servidor</h2>
          </div>
          
          <div className="config-section-content">
            <div className="config-info-card">
              {loading ? (
                <p className="config-info-loading">Cargando configuración...</p>
              ) : error ? (
                <p className="config-info-error">{error}</p>
              ) : (
                <>
                  <div className="config-info-item">
                    <FolderOpen size={20} className="config-info-icon" />
                    <div className="config-info-details">
                      <span className="config-info-label">Directorio de Datos:</span>
                      <span className="config-info-value">{folderPath}</span>
                    </div>
                  </div>
                  <div className="config-info-item">
                    <Server size={20} className="config-info-icon" />
                    <div className="config-info-details">
                      <span className="config-info-label">Ambiente:</span>
                      <span className="config-info-value config-info-badge">
                        {environment}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
      </div>
      
      <div className="configuracion-footer">
        <p className="configuracion-footer-text">
          Los archivos se almacenan en la carpeta configurada en OneDrive
        </p>
      </div>
    </div>
  );
};

export default ConfiguracionOneDrive;
